import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDialog, {
    attrs: {
      "width": "80%",
      "max-width": "1000px",
      "dark": ""
    },
    model: {
      value: _vm.showPreviewDialog,
      callback: function ($$v) {
        _vm.showPreviewDialog = $$v;
      },
      expression: "showPreviewDialog"
    }
  }, [_c('div', {
    staticClass: "preview",
    style: _vm.UiTheme ? 'color: #fff !important; background: #111 !important;' : 'color: #111 !important; background: #fff !important;'
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewSubject)
    }
  }), _c('hr'), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewBody)
    }
  })])]), _c(VExpansionPanelHeader, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_vm._v("\n      " + _vm._s(_vm.getTemplateTitle(_vm.id)) + "\n      "), _vm.isEmpty || _vm.errorSubject || _vm.errorBody ? _c(VIcon, {
    staticClass: "ml-2",
    attrs: {
      "dense": "",
      "small": "",
      "color": "danger"
    }
  }, [_vm._v("\n        fal fa-exclamation-triangle\n      ")]) : _vm._e()], 1)]), _c(VExpansionPanelContent, [_c('div', {
    staticClass: "mt-2"
  }, [_c(VTextField, {
    ref: "inputSubject",
    style: _vm.inputTemplateStyle,
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "rules": [v => !Boolean(_vm.errorSubject) && !!v || ''],
      "label": _vm.$i18n_t('accMgmt.system.email.templates.subject'),
      "spellcheck": "false",
      "autocomplete": "off",
      "hide-details": ""
    },
    on: {
      "change": _vm.updateSubject,
      "blur": _vm.renderTemplate
    },
    model: {
      value: _vm.internalSubject,
      callback: function ($$v) {
        _vm.internalSubject = $$v;
      },
      expression: "internalSubject"
    }
  }), !_vm.isMobile ? _c('span', [Boolean(_vm.errorSubject) ? _c(VBtn, {
    staticClass: "mt-2 v-btn-x",
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-danger`,
    attrs: {
      "text": "",
      "rounded": "",
      "color": "danger"
    },
    on: {
      "click": _vm.handleShowSubjectError
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fa fa-exclamation-triangle")])], 1) : _vm._e()], 1) : _c('span', [Boolean(_vm.errorSubject) ? _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-danger`,
    attrs: {
      "color": "danger",
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.handleShowSubjectError
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa fa-exclamation-triangle")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "actions mt-2"
  }, [_c(VSimpleTable, {
    attrs: {
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _c('th', {
    attrs: {
      "width": "10"
    }
  }), _c('th', [_vm._v("Variable")])])]), _c('tbody', _vm._l(_vm.varsSubject, function (item, idx) {
    return _c('tr', {
      key: `var-${idx}`
    }, [_c('td', [_vm._v(_vm._s(_vm.getVariableName(item.key)))]), _c('td', {
      attrs: {
        "width": "10"
      }
    }), _c('td', {
      staticClass: "variable-value"
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)])], 1), _c(VTextarea, {
    ref: "inputBody",
    staticClass: "body-template mt-6",
    style: _vm.inputTemplateStyle,
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "rules": [v => !Boolean(_vm.errorBody) && !!v || ''],
      "label": _vm.$i18n_t('accMgmt.system.email.templates.body'),
      "rows": "15",
      "spellcheck": "false",
      "autocomplete": "off",
      "hide-details": ""
    },
    on: {
      "keydown": _vm.handleTemplateKeydown,
      "change": _vm.updateBody,
      "blur": _vm.renderTemplate
    },
    model: {
      value: _vm.internalBody,
      callback: function ($$v) {
        _vm.internalBody = $$v;
      },
      expression: "internalBody"
    }
  }), !_vm.isMobile ? _c('span', [Boolean(_vm.errorBody) ? _c(VBtn, {
    class: `v-btn-x mx-1 mt-4 v-btn--rounded bg-rounded-button-danger`,
    attrs: {
      "color": "danger",
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.handleShowBodyError
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fa fa-exclamation-triangle")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.buttonShowError')) + "\n        ")], 1) : _vm._e()], 1) : _c('span', [Boolean(_vm.errorBody) ? _c(VBtn, {
    class: `v-btn-x mx-1 mt-2 v-btn--rounded bg-rounded-button-danger`,
    attrs: {
      "color": "danger",
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.handleShowBodyError
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fa fa-exclamation-triangle")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "actions mt-2"
  }, [_c(VSimpleTable, {
    attrs: {
      "dense": ""
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-left"
  }, [_c('th', [_vm._v("Description")]), _c('th', {
    attrs: {
      "width": "10"
    }
  }), _c('th', [_vm._v("Variable")])])]), _c('tbody', _vm._l(_vm.varsBody, function (item, idx) {
    return _c('tr', {
      key: `var-${idx}`
    }, [_c('td', [_vm._v(_vm._s(_vm.getVariableName(item.key)))]), _c('td', {
      attrs: {
        "width": "10"
      }
    }), _c('td', {
      staticClass: "variable-value"
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)])], 1)], 1), !_vm.isMobile ? _c('span', [_c(VBtn, {
    staticClass: "v-btn-x mt-4",
    class: `v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": Boolean(_vm.errorSubject) || Boolean(_vm.errorBody) || _vm.isEmpty,
      "rounded": "",
      "text": "",
      "color": _vm.color
    },
    on: {
      "click": _vm.handlePreview
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-eye")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('accMgmt.system.buttonPreview')) + "\n      ")], 1)], 1) : _c('span', [_c(VBtn, {
    class: `v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": Boolean(_vm.errorSubject) || Boolean(_vm.errorBody) || _vm.isEmpty,
      "color": _vm.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": _vm.handlePreview
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-eye")])], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };